import React, { useContext } from "react";
import "./PageThirteen.scss";
import { BuildingsContext } from "../../../bContext";
import opis from "../../../assets/opis.PNG"
import opisEn from "../../../assets/descEn.png"

function PageThirteen() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );
  return (
    <>
    <div className="pageThirteen">
      <div className="speech-bubble4">
      {switchToEnglish === false ?
        <p className="first">
         Każde okno posiada swoje menu, podzielone na trzy działy, <span>opis</span>, <span>zdjęcia</span> i <span>film</span>.
        </p>
        :
        <p className="first">
        Each window has its own menu, divided into three sections, <span> description </span>, <span> photos </span> i <span> video </span>.
       </p>
      }
        <div className="inner-triangle-right4"></div>
      </div>
      <div className="menu-pg4" style={{backgroundImage: !switchToEnglish ? `url(${opis})` : `url(${opisEn})`, height: switchToEnglish && "5rem" }}></div>

      <div>
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </div>      
    </>
  );
}

export default PageThirteen;
